export function country2currency(country: string) {
  let c = "€";
  if (country) {
    switch (country.toLowerCase()) {
      case "*netherlands":
      case "netherlands":
        c = "€";
        break;
      case "*england":
      case "england":
      case "uk":
      case "united kingdom":
      case "great britain":
        c = "£";
        break;
      default:
        // console.log(country);
        break;
    }
  }
  return c;
}

export function formatCurrency(amount: number) {
  const hasCents = amount % 1 !== 0;

  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).format(amount);
}
